// // servicesApi.js
// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL;






// // Format date for backend (yyyy-MM-dd HH:mm:ss)
// const formatDateForBackend = (date) => {
//   const d = new Date(date);
//   const yyyy = d.getFullYear();
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const dd = String(d.getDate()).padStart(2, "0");
//   const hh = String(d.getHours()).padStart(2, "0");
//   const min = String(d.getMinutes()).padStart(2, "0");
//   const ss = String(d.getSeconds()).padStart(2, "0");
//   return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
// };


// // 1. Fetch all services from the backend (no filtering yet)

// export const getAllServices = async (status = "all") => {
//   const { data } = await axios.get(
//     `${API_URL}/api/v1/report/massReportForServiceDetailsList?status=${status}`
//   );

//   return (data || []).map((item) => {
//     const planList = item.planList || [];
//     const serviceStatus = planList.some((p) => p.planStatus === "1")
//       ? "1"
//       : "0";

//     return {
//       serviceInfo: {
//         SERVICE_ID: item.serviceId,
//         SERVICE_NAME: item.serviceName,
//         SERVICE_CATEGORY: item.serviceCategory,
//         SERVICE_DESCRIPTION: item.serviceDescription,
//         SERVICE_FEATURES: item.serviceFeatures,
//         SERVICE_BENEFITS: item.serviceBenefits,
//       },
//       serviceReleaseDate: item.serviceReleaseDate || "-",
//       serviceStatus,
//       planInfo: planList.map((p) => ({
//         PLAN_ID: p.planId,
//         PLAN_NAME: p.planName,
//         PLAN_TOTAL_COST: p.planPrice,
//         PLAN_STATUS: p.planStatus,
//         NUMBER_OF_UNITS_SOLD: p.unitsSold,
//         SALE_AMOUNT: p.saleAmount,
//         PLAN_TOTAL_CALL_MINUTES: p.planTotalCallMinutes,
//         PLAN_TOTAL_MESSAGES: p.planTotalMessages,
//         PLAN_TOTAL_COST: p.planProductPrice,
//       })),
//     };
//   });
// };


// // 2. Filter services by status ("1" = active, "0" = inactive, "all" = no filter)
// export const filterServicesByStatus = (services, status = "all") => {
//   if (status === "all") return services;
//   return services.filter((s) => s.serviceStatus === status);
// };



// // 2. Create service (with planInfo)
// export const addService = async (serviceData) => {
//   const payload = {
//   serviceName: serviceData.serviceName,
//   serviceDescription: serviceData.serviceDescription,
//   serviceFeatures: serviceData.serviceFeatures,
//   serviceBenefits: serviceData.serviceBenefits,
//   serviceReleaseDate: formatDateForBackend(serviceData.serviceReleaseDate),
//   serviceCategory: serviceData.serviceCategory,
//   planInfo: serviceData.planInfo || [],
//  };



//   const { data } = await axios.post(
//     `${API_URL}/api/v1/serviceDetails/createService`,
//     payload
//   );
//   return data;
// };


// // 4. Delete service
// export const deleteService = async (serviceId) => {
//   await axios.delete(`${API_URL}/api/v1/serviceDetails/deleteService/${serviceId}`);
// }


// // 5. Add a plan to a specific service
// export const addPlanToService = async (serviceId, planData) => {
//   const numericId = serviceId.includes('#') ? serviceId.split('#')[1] : serviceId;

//   const payload = {
//     planName: planData.planName,
//     planStatus: planData.planStatus,
//     planTotalCallMinutes: planData.planTotalCallMinutes,
//     planTotalMessages: planData.planTotalMessages,
//     planProductPrice: planData.planProductPrice,
//     numberOfUnitsSold: planData.numberOfUnitsSold || "0",
//   };

//   const { data } = await axios.post(
//     `${API_URL}/api/v1/serviceDetails/${numericId}`,
//     payload
//   );
//   return data;
// };



// // 3. Update service (no planInfo; serviceId in path)
// export const updateService = async (serviceId, serviceData) => {
//   const payload = {
//   serviceName: serviceData.serviceName,
//   serviceDescription: serviceData.serviceDescription,
//   serviceFeatures: serviceData.serviceFeatures,
//   serviceBenefits: serviceData.serviceBenefits,
//   serviceReleaseDate: formatDateForBackend(serviceData.serviceReleaseDate),
//   serviceCategory: serviceData.serviceCategory,
//   planInfo: serviceData.planInfo || [] ,
// };

//  const serviceParam = serviceId?.replace(/^SERVICE#/, '');

//   const { data } = await axios.put(
//     `${API_URL}/api/v1/serviceDetails/updateService/${serviceParam}`,
//     payload
//   );
//   return data;
// };


// // 6. Update a specific plan for a service
// export const updatePlanOfService = async (serviceId, planId, planData) => {
//   const payload = {
//     planName: planData.planName,
//     planTotalCallMinutes: planData.planTotalCallMinutes,
//     planTotalMessages: planData.planTotalMessages,
//     planProductPrice: planData.planProductPrice,
//     planStatus: planData.planStatus,
//   };

//    const serviceParam = serviceId?.replace(/^SERVICE#/, '');

//   //const serviceParam = serviceId?.startsWith("SERVICE#") ? serviceId : `SERVICE#${serviceId}`;

//   const { data } = await axios.put(
//     `${API_URL}/api/v1/serviceDetails/${serviceParam}/${planId}`,
//     payload
//   );

//   return data;
// };


// servicesApi.js
import axios from "axios";
import authenticatedAxios from "../services/authenticatedAxios";

const API_URL = process.env.REACT_APP_API_URL;

// --------------------
// Helper: Format date
// --------------------
const formatDateForBackend = (date) => {
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
};

// -----------------------------
// 1️⃣ Get All Services (Merged)
// -----------------------------
export const getAllServices = async (status = "all") => {
  console.log("📤 Fetching All Services with Status:", status);

  try {
    // Add cache-busting parameter to ensure fresh data
    const timestamp = new Date().getTime();
    const { data } = await authenticatedAxios.get(
      `/api/v1/report/massReportForServiceDetailsList?status=${status}&_t=${timestamp}`
    );

    console.log("📦 Raw API Response (All Services):", data);

    // 🧹 Step 1: Filter out invalid/null services
    const validServices = (data || []).filter(
      (item) => item.serviceName?.trim() !== "" && item.serviceId
    );

    // 🧩 Step 2: Map and format data safely
    const formattedData = validServices.map((item) => {
      const planList = Array.isArray(item.planList) ? item.planList : [];

      // Determine service active/inactive based on plan status
      const serviceStatus = planList.some((p) => p.planStatus === "1")
        ? "1"
        : "0";

      const mappedItem = {
        serviceInfo: {
          SERVICE_ID: item.serviceId,
          SERVICE_NAME: item.serviceName?.trim() || "-",
          SERVICE_CATEGORY: item.serviceCategory || "-",
          SERVICE_DESCRIPTION: item.serviceDescription || "-",
          SERVICE_FEATURES: item.serviceFeatures || "-",
          SERVICE_BENEFITS: item.serviceBenefits || "-",
        },
        serviceReleaseDate: item.serviceReleaseDate || "-",
        serviceStatus,
        planInfo: planList.map((p) => ({
          PLAN_ID: p.planId ?? "",
          PLAN_NAME: p.planName ?? "",
          PLAN_TOTAL_CALL_MINUTES: p.planTotalCallMinutes ?? 100,
          PLAN_TOTAL_MESSAGES: p.planTotalMessages ?? 300,
          PLAN_PSF_CALL_MINUTES: p.planPsfCallMinutes ?? "",
          PLAN_PSF_MESSAGES: p.planPsfMessages ?? "",
          PLAN_SMR_CALL_MINUTES: p.planSmrCallMinutes ?? "",
          PLAN_SMR_MESSAGES: p.planSmrMessages ?? "",
          PLAN_TOTAL_COST: p.planProductPrice ?? p.planPrice ?? "0",
          PLAN_STATUS: p.planStatus ?? "0",
          NUMBER_OF_UNITS_SOLD: p.unitsSold ?? "0",
          SALE_AMOUNT: p.saleAmount ?? "0",
        })),
      };

      console.log("🧩 Processed Service Item:", mappedItem);
      return mappedItem;
    });

    console.log("✅ Final Formatted Service List:", formattedData);
    return formattedData;
  } catch (error) {
    console.error("❌ Error fetching services:", error);
    return [];
  }
};

// -------------------------------
// 2️⃣ Filter by Status (no change)
// -------------------------------
export const filterServicesByStatus = (services, status = "all") => {
  if (status === "all") return services;
  return services.filter((s) => s.serviceStatus === status);
};

// -----------------------------------
// 3️⃣ Create New Service (no change)
// -----------------------------------

// Normalize plan item so backend schema accepts (optional PSF/SMR as "0" when missing)
const normalizePlanItem = (p) => ({
  planName: p.planName ?? "",
  planStatus: p.planStatus ?? "0",
  planTotalCallMinutes: (p.planTotalCallMinutes != null && p.planTotalCallMinutes !== "") ? String(p.planTotalCallMinutes) : "0",
  planTotalMessages: (p.planTotalMessages != null && p.planTotalMessages !== "") ? String(p.planTotalMessages) : "0",
  planProductPrice: (p.planProductPrice != null && p.planProductPrice !== "") ? String(p.planProductPrice) : "0",
  planPsfCallMinutes: (p.planPsfCallMinutes != null && p.planPsfCallMinutes !== "") ? String(p.planPsfCallMinutes) : "0",
  planPsfMessages: (p.planPsfMessages != null && p.planPsfMessages !== "") ? String(p.planPsfMessages) : "0",
  planSmrCallMinutes: (p.planSmrCallMinutes != null && p.planSmrCallMinutes !== "") ? String(p.planSmrCallMinutes) : "0",
  planSmrMessages: (p.planSmrMessages != null && p.planSmrMessages !== "") ? String(p.planSmrMessages) : "0",
});


export const addService = async (serviceData) => {
  if (!serviceData || typeof serviceData !== "object") {
    throw new Error("addService: serviceData is required");
  }
  const planInfo = (serviceData.planInfo || []).map(normalizePlanItem);
  const releaseDate = serviceData.serviceReleaseDate != null && serviceData.serviceReleaseDate !== ""
    ? serviceData.serviceReleaseDate
    : new Date().toISOString().split("T")[0];


  
  const payload = {
    serviceName: serviceData.serviceName,
    serviceName: serviceData.serviceName ?? "",
    serviceDescription: serviceData.serviceDescription ?? "",
    serviceFeatures: serviceData.serviceFeatures ?? "",
    serviceBenefits: serviceData.serviceBenefits ?? "",
    serviceReleaseDate: formatDateForBackend(releaseDate),
    serviceCategory: serviceData.serviceCategory ?? "",
    planInfo,
  };

  const url = `/api/v1/serviceDetails/createService`;
  const baseURL = authenticatedAxios.defaults?.baseURL ?? "";
  console.log("📤 addService: POST", baseURL + url, payload);
  try {
    const { data } = await authenticatedAxios.post(url, payload);
    return data;
  } catch (e) {
    console.error("📤 addService: request failed", e?.message, e?.code, e?.response?.status);
    throw e;
  }
};

// ----------------------------
// 4️⃣ Delete Service (same)
// ----------------------------
export const deleteService = async (serviceId) => {
  await authenticatedAxios.delete(
    `/api/v1/serviceDetails/deleteService/${serviceId}`
  );
};

// ----------------------------
// 4️⃣.5 Delete Plan
// ----------------------------
export const deletePlan = async (serviceId, planId) => {
  const numericServiceId = serviceId.includes("#")
    ? serviceId.split("#")[1]
    : serviceId;
  
  await authenticatedAxios.delete(
    `/api/v1/serviceDetails/${numericServiceId}/plans/${planId}`
  );
};

// ------------------------------------------
// 5️⃣ Add Plan to Service (merged version)
// ------------------------------------------
export const addPlanToService = async (serviceId, planData) => {
  const numericId = serviceId.includes("#")
    ? serviceId.split("#")[1]
    : serviceId;

  const payload = {
    planName: planData.planName,
    planStatus: planData.planStatus,
    planTotalCallMinutes: planData.planTotalCallMinutes,
    planTotalMessages: planData.planTotalMessages,
    planProductPrice: planData.planProductPrice,
    planPsfCallMinutes: planData.planPsfCallMinutes,
    planPsfMessages: planData.planPsfMessages,
    planSmrCallMinutes: planData.planSmrCallMinutes,
    planSmrMessages: planData.planSmrMessages,
    numberOfUnitsSold: planData.numberOfUnitsSold || "0",
  };

  const { data } = await authenticatedAxios.post(
    `/api/v1/serviceDetails/${numericId}`,
    payload
  );
  return data;
};

// ----------------------------------------------
// 6️⃣ Update Service Info (no plan changes here)
// ----------------------------------------------
export const updateService = async (serviceId, serviceData) => {
  const payload = {
    serviceName: serviceData.serviceName,
    serviceDescription: serviceData.serviceDescription,
    serviceFeatures: serviceData.serviceFeatures,
    serviceBenefits: serviceData.serviceBenefits,
    serviceReleaseDate: formatDateForBackend(serviceData.serviceReleaseDate),
    serviceCategory: serviceData.serviceCategory,
    planInfo: serviceData.planInfo || [],
  };

  const serviceParam = serviceId?.replace(/^SERVICE#/, "");

  const { data } = await authenticatedAxios.put(
    `/api/v1/serviceDetails/updateService/${serviceParam}`,
    payload
  );
  return data;
};

// --------------------------------------------------
// 7️⃣ Update a Specific Plan for a Service (kept old)
// --------------------------------------------------
export const updatePlanOfService = async (serviceId, planId, planData) => {
  const payload = {
    planName: planData.planName,
    planTotalCallMinutes: planData.planTotalCallMinutes,
    planTotalMessages: planData.planTotalMessages,
    planProductPrice: planData.planProductPrice,
    planPsfCallMinutes: planData.planPsfCallMinutes,
    planPsfMessages: planData.planPsfMessages,
    planSmrCallMinutes: planData.planSmrCallMinutes,
    planSmrMessages: planData.planSmrMessages,
    planStatus: planData.planStatus,
  };

  const serviceParam = serviceId?.replace(/^SERVICE#/, "");

  const { data } = await authenticatedAxios.put(
    `/api/v1/serviceDetails/${serviceParam}/${planId}`,
    payload
  );

  return data;
};

// ------------------------------------------
// 8. Get available balance for call and messages (SMR+PSF)
// Pass { category: "SMR + PSF" } or { serviceName: "..." }. Uses POST so body is supported.
// Optional: params.authKey for external auth-key header.
// ------------------------------------------
export const getAvailableBalanceForCallAndMessages = async (params = {}) => {
  const { category, serviceName, authKey } = params;
  const body =
    serviceName != null && String(serviceName).trim() !== ""
      ? { "Service Name": String(serviceName).trim() }
      : { Category: (category != null && String(category).trim() !== "") ? String(category).trim() : "SMR + PSF" };
  const headers = authKey ? { "auth-key": authKey } : {};
  const { data } = await authenticatedAxios.post(
    "/api/v1/planUsageDetails/getAvaialbleBalanceForCallAndMessages",
    body,
    { headers }
  );

  return data;
};